import { useContext, useState } from "react"
import { motion } from "framer-motion"
import { Alert } from "@mui/material"
import styled from "styled-components"

import TopoMenu from "../../../componentes/gerais/TopoMenu"
import MenuLateral from "../../../componentes/gerais/Menu"
import { Campo } from "../../../componentes/form/campo"
import { Spinner } from "../../../componentes/Spinner"
import { configAnim } from "../../../servicos/config/configAnim"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import IndicacoesAPI from "../../../servicos/IndicacoesAPI"
import MensagemApp from "../../../servicos/config/MensagemApp"

const Div = styled.div`
    margin: 0rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

const TextoApoio = styled.p`
    color: #52606d;
    font-size: 0.95rem;
    line-height: 1.4rem;
    margin: 1rem 0 1.25rem;
`

export default function IndicacaoEmpresa() {
    const [menu, setMenu] = useState(false)
    const [email, setEmail] = useState("")
    const [carregando, setCarregando] = useState(false)
    const [resposta, setResposta] = useState(null)
    const [erroEmail, setErroEmail] = useState(false)

    const { dados } = useContext(ContextoGeral)

    function emailValido(valor) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor)
    }

    function handleEmail(ev) {
        setEmail(ev.target.value)
        setErroEmail(false)
        setResposta(null)
    }

    async function enviar() {
        const emailTratado = email.trim().toLowerCase()

        if (!emailValido(emailTratado)) {
            setErroEmail(true)
            setResposta(
                <Alert severity="error" className="mt-3">
                    Informe um e-mail válido para enviar a indicação.
                </Alert>
            )
            return
        }

        setCarregando(true)
        setResposta(null)

        const retorno = await IndicacoesAPI.enviarIndicacaoEmpresa(dados, emailTratado)

        if (retorno?.resultado) {
            setEmail("")
            setResposta(
                <Alert severity="success" className="mt-3">
                    {retorno?.mensagem || "E-mail de indicação enviado com sucesso."}
                </Alert>
            )
        } else {
            setResposta(
                <Alert severity="error" className="mt-3">
                    {retorno?.mensagem || MensagemApp.msgErroApi}
                </Alert>
            )
        }

        setCarregando(false)
    }

    return (
        <motion.div
            initial={configAnim.initial}
            animate={configAnim.animate}
            exit={configAnim.exit}
            transition={configAnim.transition}
            style={{ height: '100%' }}
        >
            <TopoMenu voltar="/app/home" titulo="INDIQUE UM CLIENTE" setShow={setMenu} />
            <Div>
                <div>
                    <TextoApoio>
                        Informe o e-mail do cliente que deseja indicar. Ela receberá um link seguro para concluir o cadastro.
                    </TextoApoio>

                    <Campo
                        id="email"
                        label="E-mail do cliente"
                        tipo="email"
                        className="mt-3"
                        obrigatorio
                        danger={erroEmail}
                        onChange={handleEmail}
                        value={email}
                    />

                    {resposta}
                </div>

                <button className="my-3 w-full" onClick={enviar} disabled={carregando}>
                    {carregando ? (
                        <div className="my-2">
                            <Spinner />
                        </div>
                    ) : "Enviar indicação"}
                </button>
            </Div>
            <MenuLateral show={menu} setShow={setMenu} ativo="2" />
        </motion.div>
    )
}
